<template>
    <div class="inline-flex pt-2 pb-8">
        <div class="h-1 rounded-lg w-8"
            :class="[ (step < steps) ? 'mr-3' : '', (step <= currentStep) ? 'bg-primary-500' : 'bg-gray-500' ]"
            v-for="step in steps">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: Number,
        currentStep: Number,
    },
};
</script>
